<template>
    <div class="col-sm-auto py-2" @click="closeDropdown">
        <!-- Button trigger modal -->
      <template v-if="crew.active == 1 || isSystemAdmin">
        <button class="btn btn-outline-primary btn-sm my-auto"
                data-toggle="modal" data-target="#addMedicalIncident"
                style="opacity: .75"
        >
            <i class="fas fa-plus"></i>
            Add New
        </button>
      </template>

        <!-- Modal -->
        <div class="modal fade" id="addMedicalIncident" tabindex="-1" role="dialog" aria-labelledby="addMedicalIncidentTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered  modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title font-weight-bolder" id="addMedicalIncidentTitle">Add Medical Incident</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                                id="close-new-medical-incident"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <form action="" class="small" @submit.prevent="confirmAddCrewMedicalIncident">
                        <div class="modal-body">

                            <div class="row">

                                <div class="col col-sm-3">
                                    <div class="form-group row mb-0">
                                        <label for="new-vessel" class="col-sm-4 col-form-label font-weight-bold">Vessel :</label>
                                        <div class="col-sm-8 px-0">

                                            <VesselDropdown
                                                id="new-vessel"
                                                v-model="newCrewMedicalIncident.vessel_id"
                                                :selections="vesselKeys"
                                                identifier="newVessel"
                                                :other-function="getOtherVesselKeys"
                                            ></VesselDropdown>

<!--                                            <DropdownSelect id="new-vessel"-->
<!--                                                            style="width: 75%"-->
<!--                                                            identifier="newVessel"-->
<!--                                                            :selections="vesselKeys"-->
<!--                                                            :other-function="getOtherVesselKeys"-->
<!--                                                            @updateNewVessel="newCrewMedicalIncident.vessel_id = $event"-->
<!--                                            ></DropdownSelect>-->

<!--                                            <select id="new-vessel"-->
<!--                                                    class="custom-select custom-select-sm"-->
<!--                                                    v-model="newCrewMedicalIncident.vessel_id"-->
<!--                                            >-->
<!--                                                <option :value="false">- Select Vessel -</option>-->
<!--                                                <option v-for="vesselKey in vesselKeys" :key="vesselKey.id"-->
<!--                                                        :value="vesselKey.id"-->
<!--                                                >-->
<!--                                                    {{ vesselKey.name }}-->
<!--                                                </option>-->
<!--                                            </select>-->

                                        </div>
                                    </div>

                                    <div class="form-group row mb-0">
                                        <label for="new-manning" class="col-sm-4 col-form-label font-weight-bold pr-1">
                                            Manning:
                                        </label>
                                        <div class="col-sm-8 px-0">
                                            <select id="new-manning" required
                                                    class="custom-select custom-select-sm"
                                                    v-model="newCrewMedicalIncident.manning_id"
                                            >
                                                <option :value="false">- Select Manning -</option>
                                                <option v-for="manningKey in manningKeys" :key="manningKey.id"
                                                        :value="manningKey.id"
                                                >
                                                    {{ manningKey.alias }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="col col-sm-3">
                                    <div class="form-group row mb-0">
                                        <label for="new-medical-date" class="col-sm-5 col-form-label font-weight-bold">Date :</label>
                                        <div class="col-sm-7 px-0">
                                            <input type="date" id="new-medical-date" required
                                                   class="form-control form-control-sm"
                                                   v-model="newCrewMedicalIncident.incident_date"
                                            >
                                        </div>
                                    </div>

                                    <div class="form-group row mb-0">
                                        <label for="new-medical-type" class="col-sm-5 col-form-label font-weight-bold pr-1">Medical Type :</label>
                                        <div class="col-sm-7 px-0">
                                            <select id="new-medical-type" required
                                                    class="custom-select custom-select-sm"
                                                    v-model="newCrewMedicalIncident.medical_type_id"
                                                    @change="injuries = []"
                                            >
                                                <option v-for="medicalTypeKey in medicalTypeKeys" :key="medicalTypeKey.id"
                                                        :value="medicalTypeKey.id"
                                                >
                                                    {{ medicalTypeKey.name }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="col col-sm-2">
                                    <div class="form-group row mb-0">
                                        <div class="col-sm-12 px-0 text-center pt-2">
                                            <div class="form-check form-check-inline">
                                                <input class="form-check-input" type="checkbox" id="new-at-sea" value="At Sea"
                                                       v-model="newCrewMedicalIncident.at_sea"
                                                >
                                                <label class="form-check-label font-weight-bold" for="new-at-sea">At Sea</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row mb-0">
                                        <div class="col-sm-12 px-0 text-center pt-2">
                                            <div class="form-check form-check-inline mx-5">
                                                <input class="form-check-input" type="checkbox" id="new-pni" value="P&I Case"
                                                       v-model="newCrewMedicalIncident.p_and_i"
                                                >
                                                <label class="form-check-label font-weight-bold" for="new-pni">P&I Case</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col col-sm-3">
                                    <div class="form-group row mb-0">
                                        <label for="new-port" class="col-sm-4 col-form-label font-weight-bold pr-1">
                                            Port {{ newCrewMedicalIncident.at_sea ? 'From ' : '' }}:
                                        </label>
                                        <div class="col-sm-8 px-0">
                                            <select id="new-port"
                                                    class="custom-select custom-select-sm"
                                                    v-model="newCrewMedicalIncident.port_id"
                                            >
                                                <option :value="false">- Select Port -</option>
                                                <option v-for="portKey in portKeys" :key="portKey.id"
                                                        :value="portKey.id"
                                                >
                                                    {{ portKey.name }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="form-group row mb-0" v-if="newCrewMedicalIncident.at_sea">
                                        <label for="new-port-to" class="col-sm-4 col-form-label font-weight-bold">Port To:</label>
                                        <div class="col-sm-8 px-0">
                                            <select id="new-port-to"
                                                    class="custom-select custom-select-sm"
                                                    v-model="newCrewMedicalIncident.port_to_id"
                                            >
                                                <option :value="false">- Select Port -</option>
                                                <option v-for="portKey in portKeys" :key="portKey.id"
                                                        :value="portKey.id"
                                                >
                                                    {{ portKey.name }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="col col-sm-3 offset-6" v-if="newCrewMedicalIncident.p_and_i">
                                    <div class="form-group row mb-0">
                                        <label for="new-pni-code" class="col-sm-4 col-form-label font-weight-bold px-0">PNI Case#:</label>
                                        <div class="col-sm-7 px-0">
                                            <input type="text" id="new-pni-code"
                                                   class="form-control form-control-sm"
                                                   placeholder="PNI Case Number"
                                                   v-model="newCrewMedicalIncident.pni_code"
                                            >
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div class="row" v-show="newCrewMedicalIncident.medical_type_id">

                                <div class="col-sm-12">
                                    <hr />
                                    <p class="h6 font-weight-bold">
                                        {{ newCrewMedicalIncident.medical_type_id === 1 ? 'Injury' : 'Illness' }} Form
                                    </p>
                                    <hr />
                                </div>

                                <div class="col-md-6">

                                    <div class="form-group row mb-1">
                                        <label for="injuryComplaint" class="col-sm-3 col-form-label font-weight-bold">Complaint :</label>
                                        <div class="col-sm-9 px-0">
                                            <textarea class="form-control form-control-sm" id="injuryComplaint" rows="5"
                                                      v-model="newCrewMedicalIncident.complaint"
                                                      style="resize: none"></textarea>
                                        </div>
                                    </div>

                                        <div class="form-group row mb-1">

                                            <label for="multiselect" class="col-sm-3 col-form-label pr-0 font-weight-bold"
                                                   @click="showCheckboxes"
                                            >
                                                {{ newCrewMedicalIncident.medical_type_id === 1 ? 'Injuries' : 'Illnesses' }} :
                                            </label>
                                            <div class="col-sm-9 px-0">

                                                <div class="multiselect custom-select custom-select-sm"
                                                     id="multiselect"
                                                     @click="showCheckboxes">
                                                    <div class="selectBox">
                                                        {{ newSelectedInjuries }}
                                                    </div>
                                                    <div id="new-checkboxes" class="dropdown-menu">
                                                        <div  v-for="injuryKey in medicalIssues" :key="injuryKey.id"
                                                              class="m-1"
                                                        >
                                                            <label :for="'new-injury-' + injuryKey.id">
                                                                <input type="checkbox" :id="'new-injury-' + injuryKey.id" class="mr-1"
                                                                       :value="injuryKey.id"
                                                                       v-model="injuries"
                                                                />
                                                                {{ injuryKey.name }}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        <div class="form-group row mb-1">
                                            <label for="new-injury-details" class="col-sm-3 col-form-label font-weight-bold">
                                                Details of {{ newCrewMedicalIncident.medical_type_id === 1 ? 'Injury' : 'Illness' }} :
                                            </label>
                                            <div class="col-sm-9 px-0">
                                            <textarea class="form-control form-control-sm mb-1" id="new-injury-details" rows="5"
                                                      v-model="newCrewMedicalIncident.injury_details"
                                                      style="resize: none"></textarea>
                                            </div>
                                        </div>

                                        <div class="form-group row mb-1">
                                            <label for="new-injury-files" class="col-sm-3 col-form-label font-weight-bold">
                                                {{ newCrewMedicalIncident.medical_type_id === 1 ? 'Injury' : 'Illness' }} Files :
                                            </label>

                                            <div class="col col-sm-9 custom-file">
                                                <input type="file" id="new-injury-files" multiple
                                                       accept="application/pdf"
                                                       class="custom-file-input form-control-sm"
                                                       @change="updateFileLabel('new-injury')"
                                                >
                                                <label class="custom-file-label text-nowrap overflow-hidden" for="new-injury-files"
                                                       id="new-injury-file-label"
                                                >Choose Files</label>
                                            </div>
                                        </div>

                                    <div class="form-group row mb-1">
                                        <label for="new-injury-diagnosis" class="col-sm-3 col-form-label font-weight-bold">Diagnosis :</label>
                                        <div class="col-sm-9 px-0">
                                            <textarea class="form-control form-control-sm" id="new-injury-diagnosis" rows="5"
                                                      v-model="newCrewMedicalIncident.diagnosis"
                                                      style="resize: none"></textarea>
                                        </div>
                                    </div>
                                    <div class="form-group row mb-1">
                                        <label for="new-injury-treatment" class="col-sm-3 col-form-label pr-0 font-weight-bold"
                                        >Treatment Given :</label>
                                        <div class="col-sm-9 px-0">
                                            <textarea class="form-control form-control-sm" id="new-injury-treatment" rows="5"
                                                      v-model="newCrewMedicalIncident.treatment"
                                                      style="resize: none"></textarea>
                                        </div>
                                    </div>
                                    <div class="form-group row mb-0">
                                        <label for="new-injury-examination" class="col-sm-3 col-form-label font-weight-bold">Examinations :</label>
                                        <div class="col-sm-9 px-0">
                                            <textarea class="form-control form-control-sm" id="new-injury-examination" rows="5"
                                                      v-model="newCrewMedicalIncident.examination"
                                                      style="resize: none"></textarea>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group row mb-1">
                                        <label class="col-sm-3 col-form-label font-weight-bold" for="new-patient-found">Patient Found :</label>
                                        <div class="col-sm-9 px-0">
                                            <div class="form-group row mb-0">
                                                <div class="col-sm-8 my-2 px-0">
                                                    <select class="custom-select custom-select-sm" id="new-patient-found"
                                                            v-model="newCrewMedicalIncident.medical_status_id"
                                                    >
                                                        <option :value="false">Select Patient Status</option>
                                                        <option v-for="medicalStatusKey in medicalStatusKeys"
                                                                :key="medicalStatusKey.id"
                                                                :value="medicalStatusKey.id"
                                                        >
                                                            {{ medicalStatusKey.name }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>

                                            <template v-if="newCrewMedicalIncident.medical_status_id === 2">
                                                <div class="form-group row mb-0">
                                                    <label for="lightDutyStartDate" class="col-sm-3 col-form-label px-0 font-weight-bold">Date From :</label>
                                                    <div class="col-sm-5 px-0">
                                                        <input type="date" id="lightDutyStartDate" class="form-control form-control-sm"
                                                               v-model="newCrewMedicalIncident.date_from"
                                                        >
                                                    </div>
                                                </div>
                                                <div class="form-group row mb-0">
                                                    <label for="lightDutyEndDate" class="col-sm-3 col-form-label px-0 font-weight-bold">Date To :</label>
                                                    <div class="col-sm-5 px-0">
                                                        <input type="date" id="lightDutyEndDate" class="form-control form-control-sm"
                                                               v-model="newCrewMedicalIncident.date_to"
                                                        >
                                                    </div>
                                                </div>
                                            </template>

                                            <template v-else-if="newCrewMedicalIncident.medical_status_id === 3">
                                                <div class="form-group row mb-0">
                                                    <label for="unfitWorkStartDate" class="col-sm-3 col-form-label px-0 font-weight-bold">Leave From :</label>
                                                    <div class="col-sm-5 px-0">
                                                        <input type="date" id="unfitWorkStartDate" class="form-control form-control-sm"
                                                               v-model="newCrewMedicalIncident.date_from"
                                                        >
                                                    </div>
                                                </div>
                                                <div class="form-group row mb-0">
                                                    <label for="unfitWorkEndDate" class="col-sm-3 col-form-label px-0 font-weight-bold">Leave To :</label>
                                                    <div class="col-sm-5 px-0">
                                                        <input type="date" id="unfitWorkEndDate" class="form-control form-control-sm"
                                                               v-model="newCrewMedicalIncident.date_to"
                                                        >
                                                    </div>
                                                </div>
                                            </template>

                                            <template v-else-if="newCrewMedicalIncident.medical_status_id === 4 || newCrewMedicalIncident.medical_status_id === 5">
                                                <div class="form-group row mb-0">
                                                    <label for="unfitDisembarkationDate" class="col-sm-4 col-form-label px-0 font-weight-bold">
                                                        {{ newCrewMedicalIncident.medical_status_id === 4 ? 'Disembarkation Date' : 'Date of Death' }} :
                                                    </label>
                                                    <div class="col-sm-5 px-0">
                                                        <input type="date" id="unfitDisembarkationDate" class="form-control form-control-sm"
                                                               v-model="newCrewMedicalIncident.date_from"
                                                        >
                                                    </div>
                                                </div>
                                            </template>

                                        </div>
                                    </div>
                                    <div class="form-group row my-1">
                                        <label class="col-sm-auto col-form-label font-weight-bold">Doctor's Recommendation :</label>
                                    </div>

                                    <div class="form-group row mb-1"
                                         v-for="doctorRecommendationKey in doctorRecommendationKeys"
                                         :key="doctorRecommendationKey.id"
                                    >
                                        <div class="col col-sm-9 offset-3">
                                            <input class="form-check-input" type="checkbox" :id="'new-recommendation-' + doctorRecommendationKey.id"
                                                   :value="doctorRecommendationKey.id"
                                                   v-model="doctorRecommendations"
                                                   @input="initializeRepatriationDate(doctorRecommendationKey.id)"
                                            >
                                            <label class="form-check-label"
                                                   :for="'new-recommendation-' + doctorRecommendationKey.id"
                                            >
                                                {{ doctorRecommendationKey.name }}
                                            </label>
                                        </div>

                                        <template v-if="doctorRecommendationKey.id == 3">
                                            <label for="new-hospitalization-start-date" class="col-sm-3 offset-3 col-form-label pr-0 font-weight-bold">Start Date :</label>
                                            <input type="date" id="new-hospitalization-start-date"
                                                   class="col-sm-5 px-0 form-control form-control-sm"
                                                   :disabled="!hospitalization"
                                                   @input="calculateHospitalizationDays"
                                                   v-model="crewHospitalization.date_from"
                                            >

                                            <label for="new-hospitalization-end-date" class="col-sm-3 offset-3 col-form-label pr-0 font-weight-bold">End Date :</label>
                                            <input type="date" id="new-hospitalization-end-date"
                                                   class="col-sm-5 px-0 form-control form-control-sm"
                                                   :disabled="!hospitalization"
                                                   @input="calculateHospitalizationDays"
                                                   v-model="crewHospitalization.date_to"
                                            >

                                            <label class="col-sm-3 offset-3 col-form-label pr-0 font-weight-bold">Number of Days :</label>
                                            <input type="text" disabled
                                                   class="col-sm-5 px-0 form-control form-control-sm bg-white"
                                                   v-model="crewHospitalization.days"
                                            >

                                            <label class="col-sm-3 col-form-label pr-0 font-weight-bold" for="new-hospitalization-files">Hospital Attachments :</label>
                                            <div class="col-sm-8 custom-file my-auto">
                                                <input type="file" id="new-hospitalization-files" multiple
                                                       class="custom-file-input form-control-sm"
                                                       accept="application/pdf"
                                                       :disabled="!hospitalization"
                                                       @change="updateFileLabel('new-hospitalization')"
                                                >
                                                <label class="custom-file-label text-nowrap overflow-hidden" for="new-hospitalization-files"
                                                       id="new-hospitalization-file-label"
                                                >Choose File</label>
                                            </div>
                                        </template>

                                        <template v-else-if="doctorRecommendationKey.id == 4">
                                            <label for="repatriationDate" class="col-sm-3 offset-3 col-form-label pr-0 font-weight-bold">Repatriation Date :</label>
                                            <input type="date" id="repatriationDate"
                                                   class="col-sm-5 px-0 form-control form-control-sm"
                                                   v-model="crewRepatriation.repatriation_date"
                                                   @input="calculateRepatriationDays"
                                                   :disabled="!repatriation"
                                            >

                                            <div class="col-sm-9 offset-3 form-check mb-2">
                                                <input class="form-check-input ml-2" type="checkbox" id="afterHospitalization" value="After Hospitalization">
                                                <label class="form-check-label ml-4" for="afterHospitalization">After Hospitalization</label>
                                            </div>

                                            <label for="arrivalManila" class="col-sm-3 offset-3 col-form-label pr-0 font-weight-bold">Arrival in Manila :</label>
                                            <input type="date" id="arrivalManila"
                                                   class="col-sm-5 px-0 form-control form-control-sm"
                                                   :disabled="!repatriation"
                                                   @input="calculateRepatriationDays"
                                                   v-model="crewRepatriation.arrival_date"
                                            >

                                            <label for="repatriationDays" class="col-sm-3 offset-3 col-form-label pr-0 font-weight-bold">Repatriation Days :</label>
                                            <input type="text" id="repatriationDays"
                                                   class="col-sm-5 px-0 form-control form-control-sm bg-white"
                                                   v-model="crewRepatriation.days"
                                                   disabled>

                                        </template>

                                    </div>


                                    <div class="form-group row mb-1">
                                        <label for="new-doctor-remarks" class="col-sm-3 col-form-label pr-0 font-weight-bold">Doctor's Remarks :</label>
                                        <div class="col-sm-9">
                                            <textarea class="form-control form-control-sm" id="new-doctor-remarks" rows="5"
                                                      v-model="newCrewMedicalIncident.doctor_remarks"
                                                      style="resize: none"></textarea>
                                        </div>
                                    </div>


                                    <div class="form-group row mb-0">
                                        <label class="col-sm-5 px-0 my-auto font-weight-bold" for="new-medical-files">Medical Incident Attachments :</label>
                                        <div class="col-sm-7 px-0 custom-file">
                                            <input type="file" id="new-medical-files" multiple
                                                   class="custom-file-input form-control-sm"
                                                   accept="application/pdf"
                                                   @change="updateFileLabel('new-medical')"
                                            >
                                            <label class="custom-file-label text-nowrap overflow-hidden" for="new-medical-files" id="new-medical-file-label">Choose FIle</label>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary btn-sm mx-1 float-right" data-dismiss="modal">
                                <i class="fas fa-times"></i>
                                Close
                            </button>

                            <button type="submit" class="btn btn-primary btn-sm float-right">
                                <i class="fas fa-plus"></i>
                                Add Incident
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import { vueAppMixin } from "@/mixins/vueAppMixin";
import { mapActions, mapGetters } from 'vuex';
import { formMixin } from "@/mixins/formMixin";
import { dataMixin } from "@/mixins/dataMixin";
import { gateMixin } from "@/mixins/gateMixin";
// import Multiselect from 'vue-multiselect';
// import DropdownSelect from "@/components/elements/DropdownSelect";
import VesselDropdown from "@/components/elements/VesselDropdown";

export default {
    name: "AddMedicalIncident",

    mixins:[ vueAppMixin, formMixin, dataMixin, gateMixin ],

    components: {
        // Multiselect,
        // DropdownSelect,
        VesselDropdown
    },

    data() {
        return {
            newCrewMedicalIncident: {},
            injuries: [],
            doctorRecommendations: [],
            crewHospitalization: {},
            crewRepatriation: {},
            expanded: false,
        }
    },
    methods: {
        ...mapActions([ 'addCrewMedicalIncident', 'getOtherVesselKeys' ]),
        showCheckboxes() {
            let checkboxes = document.getElementById("new-checkboxes");
            if (!this.expanded) {
                checkboxes.style.display = "block";
                this.expanded = true;
            } else {
                checkboxes.style.display = "none";
                this.expanded = false;
            }
        },

        closeDropdown(source) {
            if(this.expanded) {
                let node = source.target;
                let included = false;
                while (node.parentElement) {
                    if(node.id === 'multiselect') {
                        included = true;
                        break;
                    }
                    node = node.parentElement;
                }
                if(!included) this.showCheckboxes();
            }
        },

        async confirmAddCrewMedicalIncident() {
            if(await this.confirmCreateAlert()) {
                let formData = new FormData();
                formData.append('crew_id', this.crew.id);
                Object.keys(this.newCrewMedicalIncident).forEach(key => {
                    if(this.newCrewMedicalIncident[key]) {
                        let value = this.newCrewMedicalIncident[key] ? this.newCrewMedicalIncident[key] : '';
                        if(value === '0000-00-00') value = '';
                        if(value === true) value = 1;
                        formData.append(key, value);
                    }
                });

                // if(this.newCrewMedicalIncident.medical_type_id === 1) {
                    if(this.injuries.length) {
                        formData.append('newInjuries', JSON.stringify(this.injuries));
                    }

                    let input = document.getElementById('new-injury-files');
                    if (input.files && input.files.length) {
                        for(let i=0; i<input.files.length; i++) {
                            formData.append(`injuryAttachments[]`, input.files[i]);
                        }
                    }
                // } else {
                //     formData.append('injury_details', '');
                // }

                if(this.doctorRecommendations.length) {
                    formData.append('doctorRecommendations', JSON.stringify(this.doctorRecommendations));
                }

                if(this.hospitalization) {
                    formData.append('crewHospitalization', JSON.stringify(this.crewHospitalization));
                    let hospitalizationAttachments = document.getElementById('new-hospitalization-files');
                    if (hospitalizationAttachments.files && hospitalizationAttachments.files.length) {
                        for(let i=0; i<hospitalizationAttachments.files.length; i++) {
                            formData.append(`hospitalizationAttachments[]`, hospitalizationAttachments.files[i]);
                        }
                    }
                }

                if(this.repatriation) {
                    formData.append('crewRepatriation', JSON.stringify(this.crewRepatriation));
                }

                let medicalAttachments = document.getElementById('new-medical-files');
                if (medicalAttachments.files && medicalAttachments.files.length) {
                    for(let i=0; i<medicalAttachments.files.length; i++) {
                        formData.append(`medicalAttachments[]`, medicalAttachments.files[i]);
                    }
                }

                let newCrewMedicalIncident = await this.addCrewMedicalIncident(formData);
                if (newCrewMedicalIncident) {
                    if(newCrewMedicalIncident.errors) {
                        this.newCrewMedicalIncident = newCrewMedicalIncident.errors;
                    } else {
                        document.getElementById('close-new-medical-incident').click();
                        this.successAlert('Crew Medical Incident Successfully Saved', 'SAVE');
                        this.refreshNewData();
                        this.$emit('formSubmitted');
                    }
                } else {
                    this.errorAlert('Crew Medical Incident Failed to Save', 'CREATE');
                }
            }
        },

        async initializeData() {
            this.refreshNewData();
        },

        refreshNewData() {
            this.newCrewMedicalIncident = {
                medical_type_id: 1,
                vessel_id: this.crew.currentVesselId ? this.crew.currentVesselId : 0,
                port_id: false,
                port_to_id: false,
                medical_status_id: false,
                at_sea: false,
                p_and_i: false,
                manning_id: this.crew.manning_id,
            };
            this.injuries = [];
            this.doctorRecommendations = [];
            this.crewHospitalization = {};
            this.crewRepatriation = {};
        },

        calculateHospitalizationDays() {
            if(this.crewHospitalization.date_from && this.crewHospitalization.date_to) {
                let dateFrom = new Date(this.crewHospitalization.date_from);
                let dateTo = new Date(this.crewHospitalization.date_to);
                let daysDifference = (dateTo.getTime() - dateFrom.getTime()) / (1000 * 3600 * 24)
                this.crewHospitalization.days = daysDifference
            }
        },

        initializeRepatriationDate(recommendationId) {
            if(recommendationId == 3 || recommendationId == 4) {
                let hospitalization = document.getElementById('new-recommendation-' + 3).checked;
                let repatriation = document.getElementById('new-recommendation-' + 4).checked;
                if(repatriation && hospitalization && !this.crewRepatriation.repatriation_date) {
                    this.crewRepatriation.repatriation_date = this.crewHospitalization.date_to;
                }
            }
        },

        calculateRepatriationDays() {
            if(this.crewRepatriation.repatriation_date && this.crewRepatriation.arrival_date) {
                let dateFrom = new Date(this.crewRepatriation.repatriation_date);
                let dateTo = new Date(this.crewRepatriation.arrival_date);
                let daysDifference = (dateTo.getTime() - dateFrom.getTime()) / (1000 * 3600 * 24)
                this.crewRepatriation.days = daysDifference
            }
        },

        updateFileLabel(labelIdentifier) {
            let fileInput = document.getElementById(labelIdentifier + '-files');
            let labelId = labelIdentifier + '-file-label';
            let fileLabel = document.getElementById(labelId);
            let labelText = 'Choose File';
            if (fileInput.files && fileInput.files.length) {
                let fileList = [];
                fileInput.files.forEach(file => fileList.push(file.name))
                labelText = fileList.join(', ');
            }
            fileLabel.innerHTML = labelText;
        }

    },

    computed: {
        ...mapGetters([
            'vesselKeys',
            'portKeys',
            'medicalTypeKeys',
            'injuryKeys',
            'medicalStatusKeys',
            'doctorRecommendationKeys',
            'manningKeys',
            'crew'
        ]),

        newSelectedInjuries () {
            let injuries = 'Click to Select ' + (this.newCrewMedicalIncident.medical_type_id === 1 ? 'Injuries' : 'Illnesses');
            if(this.injuries.length) {
                injuries = this.injuryKeys
                .filter(injuryKey => this.injuries.some(injury => injury === injuryKey.id))
                    .map(injuryKey => injuryKey.name)
                .join(', ');
            }
            return injuries;
        },

        hospitalization() {
            return this.doctorRecommendations.some(doctorRecommendation => doctorRecommendation == 3)
        },

        repatriation() {
            return this.doctorRecommendations.some(doctorRecommendation => doctorRecommendation == 4)
        },

        medicalIssues() {
            return this.injuryKeys.filter(injuryKey => {
                return injuryKey.is_illness == (this.newCrewMedicalIncident.medical_type_id === 2)
            });
        }

    },

  watch: {
      'newCrewMedicalIncident.vessel_id'(){
        this.newCrewMedicalIncident.vessel_id == 0 ? this.newCrewMedicalIncident.vessel_id = 1 : this.newCrewMedicalIncident.vessel_id ;
        // console.log(this.newCrewMedicalIncident.vessel_id);
      },

  },

    created() {
        this.initializeData();
    }
}
</script>

<style scoped>
.multiselect {
    width: 91%;
    height: auto;
    /*min-height: 24px;*/
    /*max-height: 24px;*/
    cursor: pointer;
}

.selectBox {
    position: relative;
}

.selectBox select {
    width: 100%;
    font-weight: bold;
}

#checkboxes {
    display: none;
    border: 1px #dadada solid;
}

#checkboxes label {
    display: block;
}

#checkboxes label:hover {
    background-color: #1e90ff;
}
</style>